import React, { useContext } from 'react';
import { SMHeader, StaticContext } from '@sm/webassets';
import PropTypes from 'prop-types';
import AppDirNavHeader from '../AppDirNavHeader';
import NavHeader from '../NavHeader';

const ModernHeader = ({ v2 }) => {
  const {
    environment: { languageCode: language },
    user,
    locale: { isEUDC },
  } = useContext(StaticContext);

  return (
    <>
      <If condition={user.isAuthenticated}>
        <SMHeader
          lang={language}
          isEUDC={isEUDC}
          user={user}
          isUserAuthenticated={user.isAuthenticated}
          wrenchVariant="apps"
        />
      </If>
      <If condition={!user.isAuthenticated}>
        <Choose>
          <When condition={v2}>
            <NavHeader />
          </When>
          <Otherwise>
            <AppDirNavHeader />
          </Otherwise>
        </Choose>
      </If>
    </>
  );
};

ModernHeader.propTypes = {
  v2: PropTypes.string,
};

ModernHeader.defaultProps = {
  v2: null,
};

export default ModernHeader;
